module.exports = vendors_en_57ec70c7bf31678d927f;